import '../assets/css/servicios.css'
import {PiArmchairBold, PiCarDuotone} from 'react-icons/pi';
import {LuArmchair} from 'react-icons/lu';

function Servicios(){
    return(
        <>
            <section className="servicios" id="servicios">
            <h3 className="servicios_titulo">Nuestros Servicios</h3>
            <p className="servicios_descripcion"><b>Somos expertos en lo que hacemos! Pedinos tu presupuesto</b> <span style={{color:"var(--orange)"}}><b>sin cargo!</b></span></p>
            <div className="tips">
                <div className="tip">
                    <div className="tip__imagen tip__imagen--1"><LuArmchair size={100}/></div>
                    <span className="tip__titulo">Tapicería en general</span>
                    <span className="tip__funcion">Realizamos trabajos de tapicería en todo tipo de muebles del hogar.</span>
                </div>
                <div className="tip">
                    <div className="tip__imagen tip__imagen--2"><PiCarDuotone size={100}/></div>
                    <span className="tip__titulo">Automotor</span>
                    <span className="tip__funcion">Realizamos trabajos de tapizados en automoviles (clásicos, modernos) y en motocicletas.</span>
                </div>
                <div className="tip">
                    <div className="tip__imagen tip__imagen--3"><PiArmchairBold size={100}/></div>
                    <span className="tip__titulo">Antigüedades</span>
                    <span className="tip__funcion">Realizamos trabajos en todo tipo de muebles antiguos.</span>
                </div>
            </div>
        </section>
        </>
    )
}

export default Servicios;